import { render, staticRenderFns } from "./price-price-index.vue?vue&type=template&id=0499c4d9&scoped=true&"
import script from "./price-price-index.vue?vue&type=script&lang=js&"
export * from "./price-price-index.vue?vue&type=script&lang=js&"
import style0 from "./price-price-index.vue?vue&type=style&index=0&id=0499c4d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499c4d9",
  null
  
)

export default component.exports